<template>
  <div class="col-md-12 default">
    <equip-point />
  </div>
</template>

<script>
import equipPoint from "./EquipPoint.vue";

export default {
  name: 'EquipDeviceComponent',
  components: {
   equipPoint
  },
  props: ["type"],
  data() {
    return {
      
    };
  },
  computed: {},
  created() {
  },
  mounted() {
  },

  methods: {
   
  },
};
</script>
